import { MaskLine } from "./Reveal";

export const Philosophy = () => (
  <section data-testid="philosophy-statement-section" className="bg-obsidian py-32 sm:py-48 border-t border-line">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.35em] text-dim mb-10">{"//"} 15 — The Belief</p>
      <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.92] text-[clamp(2rem,6.5vw,6rem)] text-cream">
        <MaskLine>We do not train</MaskLine>
        <MaskLine delay={0.1}>button-pushers.</MaskLine>
        <MaskLine delay={0.2}>
          We build <span className="text-acid">creative directors</span>
        </MaskLine>
        <MaskLine delay={0.3}>who dominate the next</MaskLine>
        <MaskLine delay={0.4}>decade of visual culture.</MaskLine>
      </h2>
    </div>
  </section>
);
